import { render, staticRenderFns } from "./DuplicateDialog.vue?vue&type=template&id=f54306b4"
import script from "./DuplicateDialog.vue?vue&type=script&lang=js"
export * from "./DuplicateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports